import {FormConfig} from '../form/form.config';
import {StepComponent} from "../step/step.component";
import {StancheckAnfrage} from "./anfrage/stancheck.anfrage";

/**
 * Configuration for the input of the first chapter in the stromcheck advisor.
 * @inheritDoc
 */
export abstract class StancheckForm extends FormConfig {

  /**
   * (input) data of the user
   */
  stepComponent: StepComponent;

  /**
   * some data is needed here for validation
   */
  public anfrage: StancheckAnfrage;

  protected abstract fieldsForFormChanges;

  /**
   * @inheritDoc
   * @protected
   */
  protected formValidators = [];

  /**
   * Sets stepComponent
   * @param stepComponent
   */
  setStepComponent(stepComponent: StepComponent): void {
    this.stepComponent = stepComponent;
  }

  /**
   * Any time a field is updated, this method is called.
   * @param values
   */
  abstract updateFields(values: { [key: string]: any }): any;
  /**
   * In this function all dynamic changes of the form is done.
   * Based on selection options or value other fields are shown/hidden, options changed and validators adapted.
   *
   * @inheritDoc
   * @param values
   * @protected
   */
  protected onSetData(values: { [key: string]: any }): void {
    this.updateFields(values);
  }

  /**
   * @inheritDoc
   * @protected
   */
  protected onChange() {
    // check if the form has some fields which value changes other fields.
    if (this.fieldsForFormChanges.find(field => this.form.get(field)) !== undefined) {
      const newValues = this.updateFields(this.getData());
      if (this.stepComponent) {
        this.stepComponent.saveData(newValues);
      }
    }
  }
}
